import { closeModal } from 'features/modal/modalSlice';
import { call, put, select } from 'redux-saga/effects';
import i18n from 'i18n';
import { PayloadAction } from '@reduxjs/toolkit';
import { restreamingStarted, selectIsRestreamerSession } from 'features/restreamer/restreamerSlice';
import { notification } from 'features/notifications/toast/notification';
import { eventBus } from 'utils/eventBus';
import { logger } from 'utils/logger';
import { selectLocalUserId, selectUserById } from 'features/users/usersSlice';
import { User, UserId } from 'features/users/types';
import { RestreamingStartedPayload } from 'features/restreamer/types';

export function* onRestreamingStartedSaga(action: PayloadAction<RestreamingStartedPayload>) {
  const { initiator } = action.payload;

  logger.remote().info('Restreaming started');

  yield put(restreamingStarted());

  yield call(eventBus.sendMessage, 'restreamingStarted', { userId: initiator?.id });

  const localUserId: UserId = yield select(selectLocalUserId);
  if (localUserId === initiator?.id) {
    return;
  }

  yield put(closeModal('restreamingE2eeConsent'));

  // If the restreaming was started automatically, there won't be an initiator
  if (!initiator) {
    const isRestreamerSession: boolean = yield select(selectIsRestreamerSession);
    if (!isRestreamerSession) {
      yield call(notification, i18n.t('notifications:restreaming.started_automatically.content'));
    }

    return;
  }

  const initiatorUser: User = yield select(selectUserById, initiator.id);

  if (initiatorUser.name) {
    yield call(
      notification,
      i18n.t('notifications:restreaming.started.content', { username: initiatorUser.name })
    );
  } else {
    yield call(notification, i18n.t('notifications:restreaming.started.content_unnamed'));
  }
}
